import React, { Component } from 'react';
import { connect } from 'react-redux';
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import PageTemplate from './PageTemplate';
import { LuMailOpen, LuArrowLeft, LuDownload, LuTrash2, LuPrinter, LuMoreVertical, LuPencil } from "react-icons/lu";
import { GoMail } from "react-icons/go";

function getReplies(mailLibId, list) {
  if (!Array.isArray(list)) return [];

  const mail = list.find(item => item.mailLibId === mailLibId);
  return mail?.replyList || [];
}
function getEmployeeName(emp) {
  return emp && emp.name ? emp.name : "Unknown";
}

function getInitials(name) {
  if (!name) return "";

  const words = name.trim().split(" ");
  return words.length === 1
    ? words[0][0].toUpperCase()
    : (words[0][0] + words[1][0]).toUpperCase();
}




class AssessmentReport extends Component {
  constructor(props) {
    super(props);
    this.pdfExportComponent = React.createRef();
  }

  componentDidMount() {

  }

  exportPDFWithComponent = async () => {
    if (this.pdfExportComponent.current) {
      this.pdfExportComponent.current.save();
    }
  };


  render() {
    let { closeModal, statusData } = this.props;

    const inboxData =
      statusData?.mailIdList?.length > 0
        ? statusData.mailIdList.map((mail) => ({
          id: mail.id,

          senderName: mail.senderName,
          senderEmail: mail.senderEmail,

          recipientName: mail.recipientName,
          recipientEmail: mail.recipientEmail,

          subject: mail.subject,
          body: mail.body,

          initials: mail.senderName?.charAt(0) || "U",
          date: new Date(mail.createdAt).toLocaleDateString(),
          time: new Date(mail.createdAt).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
          fullDate: new Date(mail.createdAt).toDateString(),
          replies: getReplies(mail.id, statusData.mailReplyList || []).map((r) => ({
            id: r.id,
            repliedBy: "Replied By " + getEmployeeName(statusData.employeeId),
            initials: getInitials(getEmployeeName(statusData.employeeId)),
            message: r.body,
            date: new Date(r.createdAt).toDateString(),
            time: new Date(r.createdAt).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
          }))
        }))
        : [];


    return (
      <div className="fixed top-0 bottom-0 left-0 right-0 z-40 w-full h-full bg-black bg-opacity-60" >
        <div className="flex items-start justify-center h-screen p-4 overflow-hidden">

          <div className="mx-auto overflow-hidden overflow-y-auto bg-white rounded-md 2xl:w-7/12 xl:w-9/12 lg:w-5/6 customscroll5 h-[calc(100vh-2rem)]" >

            <div className="sticky top-0 z-20 flex flex-col items-center justify-between p-4 px-6 bg-white border-b lg:flex-row gap-4"  >
              <h1 className="text-base font-semibold text-[#212121] md:text-lg ">
                Print All Mail Responses
              </h1>

              <div className='flex md:flex-row flex-col items-center gap-2 md:w-auto w-full'>

                <div onClick={() => this.exportPDFWithComponent()}
                  className="flex items-center py-3.5 px-4 text-sm border rounded-md cursor-pointer font-medium text-[#212121] md:w-auto w-full" >
                  <span class="material-symbols-outlined mr-2">
                    file_download
                  </span> Download PDF
                </div>

                <div onClick={() => closeModal(false)} className="inline-flex items-center justify-center w-10 h-10 text-gray-500 bg-gray-100 rounded-full cursor-pointer hover:text-gray-800" >
                  <svg className="w-6 h-6 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M16.192 6.344L11.949 10.586 7.707 6.344 6.293 7.758 10.535 12 6.293 16.242 7.707 17.656 11.949 13.414 16.192 17.656 17.606 16.242 13.364 12 17.606 7.758z" />
                  </svg>
                </div>
              </div>

            </div>


            <div >
              <PDFExport ref={this.pdfExportComponent}
                pageTemplate={(pageObj) => <PageTemplate pageNum={pageObj.pageNum} />}
                scale={0.6}
                // forcePageBreak=".page-break"
                paperSize="A4"
                margin={0}
                fileName={'All Mail Responses'}
                author="InsightPlus Team"
                landscape={false}
              >
                {inboxData && inboxData.length > 0 ?
                  inboxData.map((activeMail) =>
                    <div className="p-4 md:p-6">

                      <div className="flex items-center gap-4 shrink-0 mb-6">
                        <button className="p-2 rounded-full bg-indigo-100 text-indigo-600 lg:hidden block">
                          <LuArrowLeft size={22} />
                        </button>
                        <h1 className="text-lg md:text-xl font-semibold text-gray-800">{activeMail.subject}</h1>
                      </div>

                      {/* META */}
                      <p className="text-sm md:text-base mb-4">
                        <b>From:</b> {activeMail.senderName} ({activeMail.senderEmail})
                        <br />
                        <b>To:</b> {activeMail.recipientName} ({activeMail.recipientEmail})
                      </p>

                      {/* BODY */}
                      <div
                        className="mb-6 md:text-base text-sm leading-relaxed"
                        dangerouslySetInnerHTML={{ __html: activeMail.body }}
                      />

                      {/* REPLIES */}
                      <h3 className="font-semibold md:text-lg mb-3">
                        Replies ({activeMail.replies?.length || 0})
                      </h3>

                      {activeMail.replies?.map((reply) => (
                        <div key={reply.id} className="border-b py-3 relative">

                          <div className="flex justify-between">
                            <p className="font-medium md:text-base text-sm">
                              {reply.repliedBy}
                            </p>
                          </div>

                          <div
                            className="mt-2 md:text-base text-sm"
                            dangerouslySetInnerHTML={{ __html: reply.message }}
                          />


                        </div>
                      ))}

                    </div>
                  ) : []}


              </PDFExport>
            </div>

          </div>
        </div>
      </div>

    );
  }
}
function mapStateToProps(state) {
  // //////console.log("state  ", state);
  const { loggingIn } = state.authentication;
  const { users, dashboard } = state;
  return {
    loggingIn,
    users,
    dashboard
  };
}
export default connect(mapStateToProps)(AssessmentReport);
